import { Component, Inject, ViewChild, ElementRef } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { RegistrationService, CreateUserEventBody } from '../../../services'
import { CompanyService, CompanyModel, AuthResourceService } from '../../../../resource-module'
import { FormValidators as Validators } from '../../../../forms';

@Component({
    selector: 'registration-dialog',
    templateUrl: './registration.dialog.html',
    styleUrls: ['./registration.dialog.scss']
})
export class RegistrationDialog {

    public states: string[] = ['AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY','LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'];

    public regError: string = "";

    public signupForm:FormGroup = new FormGroup({
        companyName: new FormControl({value: '', disabled: true}, []),
        companyCode: new FormControl({value: '', disabled: true}, []),
        firstName: new FormControl('', [Validators.required, Validators.maxLength(35)]),
        lastName: new FormControl('', [Validators.required, Validators.maxLength(35)]),
        email: new FormControl('', [Validators.required, Validators.email]),
        phone: new FormControl('', [Validators.required]),
        mobilePhone: new FormControl('', []),
        password: new FormControl('', [
            Validators.required,
            Validators.passwordPattern,
            Validators.minLength(8),
            Validators.maxLength(255),
            Validators.syncWith('confirmPassword')
        ]),
        confirmPassword: new FormControl('', [
            Validators.required,
            Validators.matchField('password')
        ]),
        address1: new FormControl('', [Validators.required]),
        address2: new FormControl('', []),
        city: new FormControl('', [Validators.required]),
        state: new FormControl('', [Validators.required]),
        zip: new FormControl('', [Validators.required])
    });

    public companyForm:FormGroup = new FormGroup({
        code: new FormControl('', [Validators.required]),
    });

    public confirmForm:FormGroup = new FormGroup({
        code: new FormControl('', [Validators.required]),
    });
    public step: number = 0;
    public role: string = '';
    public cognitoId: string | null = null;
    public company: CompanyModel | null = null;
    public message: string = "";
    
    // Customer User variable
    public customerId: string | null = null;

    public contact: any = {
        Phone: false,
        Email: false,
        Text: false,
    }

    constructor(
        protected _dialogRef: MatDialogRef<any>,
        protected registrationService: RegistrationService,
        protected companyService: CompanyService,
        protected authResourceService: AuthResourceService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        if(data.code) {
            this.signupForm.patchValue({companyCode: data.code, companyName: data.company.name});
            this.company = data.company;
            //this.checkCompany();            
        }
        if(data.role)
            this.role = data.role;
        if(data.step)
            this.step = data.step;
        if(data.username)
            this.cognitoId = data.username;

        this.customerId = data.customerId;

    }
    public contactChecked(name: string, event: any) {
        this.contact[name] = event.checked;
    }

    public checkCompany() {
        this.companyService.search({
			"query": {
				"term": {
					"code.keyword": this.companyForm.value.code
				}
			}
		}).subscribe((response) => {
            if(response.results.length > 0) {
                ++this.step;
                this.company = response.results[0];
                this.message = "";
                this.signupForm.patchValue({companyName: this.company.name, companyCode: this.company.code});
            } else {
                this.message = "Invalid company code.";
            }
        })
    }

    public returnToLogin() {
        this._dialogRef.close({sendToLogin: true, message: "Your account is ready"});
    }

    public toggleInputType(fieldId) {
        let elem = document.getElementById(fieldId);
        let newType = elem.getAttribute("type") === "password" ? "text" : "password";
        elem.setAttribute("type", newType)
    }

    public trimCode() {
        this.confirmForm.patchValue({
            code: this.confirmForm.value['code'].trim()
        })
    }

    public submit() {
        if(!this.signupForm.valid) {
            return
        }
        // TODO proper validation.
        if(this.signupForm.value['password'] !== this.signupForm.value['confirmPassword']) {
            return;
        }

        let userAttributes: CreateUserEventBody = {
            password: this.signupForm.value['password']
        };
        if(this.signupForm.value['email']) {
            userAttributes.email = this.signupForm.value['email'];
        }

        this.registrationService.signUp(userAttributes).subscribe((response) => {
            if(response.success == true) {
                ++this.step;
                let contact: string[] = [];
                Object.keys(this.contact).forEach((key) => {
                    if(this.contact[key])
                        contact.push(key);
                });
                this.cognitoId = response.data['Username']
				this.registrationService.userRegistration['username'] = response.data['Username'];
                this.registrationService.userRegistration['password'] = this.signupForm.value['password'];
                this.registrationService.userRegistration['firstName'] = this.signupForm.value['firstName'];
                this.registrationService.userRegistration['lastName'] = this.signupForm.value['lastName'];
                this.registrationService.userRegistration['phone'] = this.signupForm.value['phone'];
                this.registrationService.userRegistration['mobilePhone'] = this.signupForm.value['mobilePhone'];
                this.registrationService.userRegistration['email'] = this.signupForm.value['email'];
                this.registrationService.userRegistration['address1'] = this.signupForm.value['address1'];
                this.registrationService.userRegistration['address2'] = this.signupForm.value['address2'];
                this.registrationService.userRegistration['city'] = this.signupForm.value['city'];
                this.registrationService.userRegistration['state'] = this.signupForm.value['state'];
                this.registrationService.userRegistration['zip'] = this.signupForm.value['zip'];
                this.registrationService.userRegistration['contact'] = contact.join(',');
                this.registrationService.userRegistration['company'] = { id: this.company.id, name: this.company.name };
                this.registrationService.userRegistration['r'] = this.role;
                this.registrationService.userRegistration['customerId'] = this.customerId;
                this.registrationService.finalizeRegistration();
                this.message = "";
            } else {
                // TODO Handle errors.
                console.log('Error', response.message);
                let results = response.message.split('error');
                if(results.length > 1)
                    this.message = results[1].trim();
            }
        }, (error) => {
            console.log('error: ', error);
        });
    }

    public confirm() {
        this.registrationService.verifyAccount(this.cognitoId, this.confirmForm.value['code']).subscribe((response) => {
            if(response.success == true) {
                console.log(response);
                this.regError = '';
                this.returnToLogin();
            } else {
                // TODO Handle errors.
                this.regError = response.message;
                console.log('Error', response.message);
            }
        }, (error) => {
            console.log('error: ', error);
        });
    }

    public resendVerification() {
        this.authResourceService.resendVerification(this.cognitoId).subscribe( (response) => {
            if(response.success == true)
                this.regError = '';
            else
                this.regError = response.message;
            console.log(response);
        })
    }
}